import { DowngradeDetailsTypeE } from "../../../models/enums";

const getPurchaseCompleteButtonData = (type: DowngradeDetailsTypeE) => {
  let textKey = "";
  let link = "";
  let displayButton = true;

  switch (type) {
    case DowngradeDetailsTypeE.SUB_USERS:
      textKey = "purchase-complete-user-managment-button";
      link = "user/profile/account";
      break;

    case DowngradeDetailsTypeE.EXTRA_STORAGE:
      textKey = "send-files";
      link = "home";
      break;

    case DowngradeDetailsTypeE.CODES:
      textKey = "purchase-result-success-codes-list-link";
      link = "user/profile/jumbocode";
      displayButton = false;
      break;

    case DowngradeDetailsTypeE.RENEWABLE_SUBSCRIPTION:
    case DowngradeDetailsTypeE.SUBSCRIPTION:
    case DowngradeDetailsTypeE.RENEWABLE_EMBED:
    case DowngradeDetailsTypeE.EMBED:
      textKey = "send-files";
      link = "home";
      break;

    default:
      textKey = "send-files";
      link = "home";
      break;
  }

  return {
    textKey,
    link,
    displayButton,
  };
};

export default getPurchaseCompleteButtonData;
